import type { ReactElement } from 'react';
import { useModalDialog } from '@/shared/lib';
import { Button, DialogFrame } from '@/shared/ui';

interface DeleteMyDesignDialogProps {
  readonly designName: string;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
  readonly pending: boolean;
  readonly message: string | null;
}

/** 디자인 삭제 확인 — 되돌릴 수 없음을 밝히고, 이미 보낸 견적·주문은 영향이 없다고 알린다. 처리 중에는 닫지 않는다. */
export const DeleteMyDesignDialog = ({
  designName,
  onConfirm,
  onClose,
  pending,
  message,
}: DeleteMyDesignDialogProps): ReactElement => {
  const modal = useModalDialog(onClose, !pending);

  return (
    <DialogFrame
      modal={modal}
      title="디자인을 삭제할까요?"
      footer={
        <>
          <Button type="button" variant="destructive" disabled={pending} onClick={onConfirm}>
            삭제
          </Button>
          <Button type="button" variant="ghost" disabled={pending} onClick={onClose}>
            취소
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <p>
          <span className="font-semibold">{designName}</span> 디자인을 삭제합니다. 삭제하면 되돌릴
          수 없어요.
        </p>
        <p className="text-sm text-muted-foreground">
          이미 요청한 견적과 주문은 그대로 진행되며, 삭제해도 영향이 없어요.
        </p>
        {message ? (
          <p role="alert" className="text-destructive">
            {message}
          </p>
        ) : null}
      </div>
    </DialogFrame>
  );
};
